// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.shop-wrapper {
  padding: 20px;
  padding-top: 20px;
  margin-left: 50px;
}
.shop-wrapper .tilesForMobile {
  display: none;
}
.shop-wrapper article {
  display: inline-block;
  vertical-align: top;
  width: 45%;
  height: 290px;
  margin-bottom: 25px;
  margin-right: 12.6px;
  margin-left: 12.6px;
  background-color: #ffffff;
  border-radius: 30px;
}
.shop-wrapper article div {
  text-align: center;
  margin: 20px 30px 42px 30px;
}
.shop-wrapper article .tilesForDesktop {
  display: block;
}
.shop-wrapper article a {
  display: inline-block;
  text-align: center;
  margin-bottom: 15px;
  outline: none;
}
.shop-wrapper article a i {
  font-size: 50px;
  color: #ffffff;
}
.shop-wrapper article a span {
  color: black;
  font-size: 24px;
}
.shop-wrapper article p {
  font-size: 15px !important;
  color: #000000;
  text-align: left;
  line-height: 20px;
  font-weight: 400;
  font-family: "Omnes-ATT-W02";
}
.shop-wrapper article .heading-4 {
  margin-bottom: 15px;
  margin-top: 10px;
  padding-top: 10px;
  padding-bottom: 15px;
  text-align: center;
  display: block;
  font-weight: 600;
  font-size: 23px;
  text-align: left;
  color: #363636;
  font-family: "Omnes-ATT-W02";
}
.shop-wrapper article .tilesHeading {
  display: none;
}

.non5gTiles {
  display: inline-block !important;
  width: 30% !important;
  height: 350px !important;
  margin-bottom: 0px !important;
}

@media (max-width: 1024px) {
  .non5gTiles {
    display: none !important;
  }
}
@media (max-width: 1024px) {
  .dropdownMenu {
    width: 30px;
    float: right;
    margin-right: 60px;
    margin-top: -30%;
  }
  .dropdownMenuUp {
    width: 30px;
    float: right;
    margin-right: 60px;
    margin-top: -30%;
  }
  .shop-wrapper {
    overflow: hidden;
    font-weight: 500;
  }
  .shop-wrapper .tilesForMobile {
    display: block;
  }
  .shop-wrapper article {
    display: none;
    vertical-align: top;
    width: 30%;
    height: 50px;
    margin-right: 12.6px;
    margin-left: 12.6px;
    background-color: #ffffff;
    border-radius: 20px;
  }
  .shop-wrapper article .tilesForDesktop {
    display: none;
  }
  .shop-wrapper article .heading-4 {
    position: relative;
    font-weight: 600;
    height: auto;
    display: block;
    margin-bottom: 10px;
    padding-bottom: 15px 0;
    border-radius: 4px;
    padding-top: 25px !important;
  }
  .shop-wrapper article .heading-4:after p {
    font-size: 15px !important;
    color: #000000;
    text-align: left;
    line-height: 20px;
    font-weight: 400;
    font-family: "Omnes-ATT-W02";
  }
  .shop-wrapper article .shortDesc {
    font-size: 15px !important;
    color: #000000;
    text-align: left;
    line-height: 20px;
    font-weight: 400;
    font-family: "Omnes-ATT-W02";
    display: none;
  }
  .shop-wrapper article .hideLearnMore {
    display: inline-block;
    text-align: center;
    margin-bottom: 15px;
    outline: none;
    color: #FFFFFF;
  }
  .shop-wrapper article .hideLearnMore i {
    font-size: 50px;
    color: #ffffff;
  }
  .shop-wrapper article .hideLearnMore span {
    color: black;
    font-size: 24px;
  }
  .shop-wrapper article a {
    display: none;
  }
}
.learn-more-btn {
  border-radius: 10px;
  background: #3A6EB2 !important;
  font-size: 16px;
  margin-top: inherit;
  height: 40px;
  width: 175px;
}

.hideArrow {
  display: none;
  visibility: hidden;
}

.benefit-header {
  display: none;
}

.hide-benefit {
  display: block;
}

@media (max-width: 1024px) {
  .hideArrow {
    display: block;
    visibility: visible !important;
    float: right;
    margin-top: 40px;
    margin-right: -12%;
  }
  .benefit-header {
    display: block;
  }
  .hide-benefit {
    display: none;
  }
  a {
    color: #191919;
  }
}
.firstNetTC {
  padding-top: 26px;
}

.marketplace-benefit {
  background: aliceblue;
  padding: 20px 0 40px 0;
}
.marketplace-benefit h2 {
  margin-bottom: 20px;
  font: 18px "Omnes-ATT-W02";
  text-align: center;
  font-size: 34px;
  font-weight: 900;
}
.marketplace-benefit .subtitle {
  font: 16px "Omnes-ATT-W02";
  line-height: 22px;
  margin: 0 0 0 20px;
}
.marketplace-benefit img {
  max-width: 240px;
  width: 100%;
}
.marketplace-benefit .small-container-flex {
  max-width: 240px;
  width: 100%;
  margin-left: 10%;
  margin-right: 10%;
}

.signup-section {
  background: aliceblue;
  padding: 10px 0;
}
.signup-section h3 {
  font-family: "Omnes-ATT-W02";
  font-size: 1.8rem;
  margin-bottom: 26px;
}
.signup-section h3.contact-number {
  font: 2rem "Omnes-ATT-W02-Medium";
  margin-bottom: 12px;
}
.signup-section h3.contact-number-last {
  font: 2rem "Omnes-ATT-W02-Medium";
  margin-bottom: 20px;
}
.signup-section p {
  font-family: "Omnes-ATT-W02";
  font-size: 15px;
}

.signup-section-fn {
  background: #333333;
  color: white;
  padding: 0;
}
.signup-section-fn h3 {
  font-family: "Omnes-ATT-W02";
  font-size: 1.8rem;
  margin-bottom: 26px;
}
.signup-section-fn h3.contact-number {
  font: 2rem "Omnes-ATT-W02-Medium";
  margin-bottom: 12px;
}
.signup-section-fn h3.contact-number-last {
  font: 2rem "Omnes-ATT-W02-Medium";
  margin-bottom: 20px;
}
.signup-section-fn p {
  font-family: "Omnes-ATT-W02";
  font-size: 1.8rem;
}

@media (max-width: 1024px) {
  .learn-more-btn {
    border-radius: 10px;
    background: #3A6EB2 !important;
    font-family: "Omnes-ATT-W02";
    font-size: 16px;
    margin-top: inherit;
    height: 40px;
  }
}
.inner-container-box {
  padding-left: 60px !important;
  padding-right: 60px !important;
}

@media (max-width: 1024px) {
  .inner-container-box {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
}
.terms {
  display: flex;
  flex-direction: row;
}

@media (max-width: 1024px) {
  .terms {
    flex-direction: column;
  }
}
.termscolumns1 {
  flex: 55%;
}
@media (max-width: 1024px) {
  .termscolumns1 {
    flex: 50%;
  }
}

.termscolumns2 {
  flex: 45%;
}
@media (max-width: 1024px) {
  .termscolumns2 {
    flex: 50%;
  }
}

@media (max-width: 1024px) {
  .termscols {
    float: left;
  }
}
.container-flex {
  display: flex;
  flex-direction: row;
}

@media (max-width: 1024px) {
  .container-flex {
    flex-direction: column;
    align-items: center;
    display: block;
  }
}
.footer-description {
  font-size: 15px;
  color: #000000;
  opacity: 1;
  margin-bottom: 0px;
}

.hide-small {
  display: block;
  visibility: visible !important;
}

.show-small {
  display: none;
  visibility: hidden;
}

@media (max-width: 1024px) {
  .hide-small {
    display: none;
    visibility: hidden;
  }
  .show-small {
    display: block;
    visibility: visible !important;
  }
}
@media (min-width: 501px) and (max-width: 1024px) {
  app-page-slider {
    height: 266px !important;
    margin-top: 50px;
  }
  app-page-slider .page .caption-text {
    left: 10% !important;
    width: 60% !important;
  }
}
.inner {
  height: 500px;
  position: absolute;
  top: 0;
  will-change: left;
}

@media (max-width: 500px) {
  app-page-slider {
    height: 266px !important;
    margin-top: 50px;
  }
}
app-page-slider {
  height: 436px;
  width: 100%;
}
app-page-slider .page {
  height: 436px !important;
  overflow: hidden;
  text-align: center;
}
app-page-slider .page img {
  left: 50%;
  max-width: none;
  position: absolute;
  transform: translateX(-50%);
  width: auto;
}
app-page-slider .page small {
  font-size: 11px;
}
app-page-slider .page .caption-text {
  transform: translateY(-50%);
  transform: translateY(-50%);
  transform: translateY(-50%);
  transform: translateY(-50%);
  transform: translateY(-50%);
  font-size: 1.4rem;
  position: absolute;
  text-align: left;
  top: 152px;
  width: 100%;
}
app-page-slider .page .caption-text .container-inner {
  padding-left: 80px !important;
  padding-right: 120px;
}
app-page-slider .page .caption-text .btn-primary {
  /* For Safari 5.1 to 6.0 */
  /* For Opera 11.1 to 12.0 */
  /* For Firefox 3.6 to 15 */
  background: linear-gradient(to bottom, #ea7400 100%, #ea7400 50%, #ea7400 0%, #d16500);
  font-size: 20px;
  padding-top: 7px;
}
app-page-slider .page .caption-text h1 {
  font: 38px "Omnes-ATT-W02";
  line-height: normal;
  font-weight: 430;
  margin-bottom: 15px;
  margin-top: 0;
}
app-page-slider .page .caption-text .eyebrow-text {
  font-size: 18px;
}
app-page-slider .page .caption-text .caption-white {
  color: white !important;
}
app-page-slider .page .caption-text p {
  font-size: 16px;
}
app-page-slider .page .caption-text .caption-background {
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.8);
  color: white !important;
  padding: 30px;
}
app-page-slider .page .caption-text .carouselDiv0 .carouselDiv2 h1 {
  color: white !important;
}
@media (max-width: 1024px) {
  app-page-slider .page .caption-text {
    transform: none;
    transform: none;
    transform: none;
    transform: none;
    transform: none;
    background: transparent;
    bottom: 90px;
    color: white;
    top: 0px;
    left: 20px;
    width: 70%;
  }
  app-page-slider .page .caption-text h1 {
    font-size: 2rem;
    margin-bottom: 10px;
    margin-top: 14px;
  }
  app-page-slider .page .caption-text p {
    line-height: initial;
    margin-bottom: 14px;
  }
  app-page-slider .page .caption-text .btn {
    margin-bottom: 20px;
    width: 50%;
    font-size: 12px;
  }
  app-page-slider .page .caption-text .caption-background {
    background: none;
    padding: 0 15px;
  }
  app-page-slider .page .caption-text .eyebrow-text {
    font-size: 14px;
    margin-top: 20px;
  }
  app-page-slider .page .caption-text .container-inner {
    padding-left: 0px !important;
    padding-right: 0px;
  }
}
app-page-slider .page .caption-text a {
  color: rgb(255, 255, 255);
  text-decoration: underline;
}
app-page-slider .page .caption-text a.btn-secondary {
  text-decoration: none;
}
app-page-slider .right-nav {
  font-size: 50px !important;
}

app-nav-button {
  position: absolute;
  top: 0;
}
app-nav-button[backward] {
  left: 15px;
}
app-nav-button[forward] {
  right: 15px;
}

.row {
  margin-left: 0px !important;
  margin-right: 0px !important;
}

@media (max-width: 1024px) {
  .btn {
    text-align: center;
  }
  .shop-wrapper {
    padding: 40px 0 10px;
  }
  .shop-wrapper article {
    display: block;
    margin: 0 auto;
    width: 90%;
    height: 100%;
    margin-left: 0px;
  }
  .shop-wrapper article .align {
    padding-top: 0px;
  }
  .shop-wrapper article p {
    font-size: 14px;
  }
  .shop-wrapper article a span {
    font-size: 18px;
  }
  .shop-wrapper article a i {
    font-size: 36px;
  }
  .shop-wrapper article .heading-4 {
    margin-bottom: 15px;
    margin-top: 10px;
    padding-top: 20px !important;
    padding-bottom: 20px !important;
    text-align: center;
    display: block;
    font-weight: 600;
    font-size: 23px;
    text-align: left;
    color: #363636;
    font-family: "Omnes-ATT-W02";
  }
  .marketplace-benefit {
    padding: 30px 0 20px 0;
    margin-right: 2%;
    margin-left: 2%;
  }
  .marketplace-benefit h2 {
    font: 26px "Omnes-ATT-W02";
    margin-bottom: 30px;
    margin: 55px 0 10px 0;
    font-weight: 900;
  }
  .marketplace-benefit .subtitle {
    font: 14px "Omnes-ATT-W02";
  }
  .marketplace-benefit .subtitle li {
    line-height: 10px;
  }
  .marketplace-benefit img {
    padding: 0;
    margin-left: auto;
    margin-right: auto;
    max-width: 300px;
  }
  .marketplace-benefit .small-container-flex {
    padding: 0;
    margin-left: auto;
    margin-right: auto;
    max-width: 300px;
  }
  .signup-section {
    padding: 10px 0 10px;
  }
  .signup-section h3 {
    font-size: 14px;
    margin-bottom: 20px;
  }
  .signup-section p {
    font-size: 15px;
    line-height: 18px;
  }
  .signup-section-fn {
    padding: 0px;
  }
  .signup-section-fn h3 {
    font-size: 14px;
    margin-bottom: 20px;
  }
  .signup-section-fn p {
    font-size: 14px;
    line-height: 18px;
  }
  app-nav-button {
    display: none;
    position: absolute;
    top: 0;
  }
}
.link-white {
  color: rgb(255, 255, 255);
  text-decoration: underline;
}

:host ::ng-deep .container-box.inner-wrap {
  padding-left: 200px !important;
  padding-right: 200px;
}

@media (max-width: 1024px) {
  .second-row {
    max-width: 360px;
  }
}
@media (max-width: 1024px) {
  :host ::ng-deep .container-box.inner-wrap {
    padding-left: 0px !important;
    padding-right: 0px;
  }
}
:host ::ng-deep .link-text {
  color: #1483d9 !important;
  text-decoration: none;
  font-size: 15px;
}

:host ::ng-deep .link-text:hover {
  text-decoration: underline;
}

:host ::ng-deep i.nav-right-icon {
  color: #f2f2f2;
}

:host ::ng-deep i.nav-left-icon {
  color: #f2f2f2;
}

.learn-more-button {
  border-radius: 10px;
  background: #f2f2f2 !important;
  padding: 10px 18px 10px 18px;
  font-weight: 500;
  font-family: "Omnes-ATT-W02";
}

.left-align {
  text-align: right;
}

@media (max-width: 1024px) {
  .left-align {
    margin-top: 10px;
    text-align: left;
  }
}
.small-container-flex {
  display: flexbox;
}

.article-list {
  transform: translate(0%, -25%);
}

@media (max-width: 1024px) {
  .article-list {
    transform: translate(0%, 0%);
    padding-top: 0px;
    padding-bottom: 0px;
  }
}
.slider-heading {
  color: #FFFFFF;
  font-weight: 400;
  font-size: 35px;
  line-height: 21px;
  font-family: "Omnes-ATT-W02";
}

:host ::ng-deep app-page-slider[_ngcontent-yqi-c10] .page[_ngcontent-yqi-c10] .caption-text[_ngcontent-yqi-c10] {
  bottom: 90px;
  left: 46px;
  width: 65%;
  margin-top: -20px;
}

@media (max-width: 1024px) {
  .slider-title {
    font-size: 26px !important;
  }
  .slider-short-description {
    font-size: 12px !important;
  }
}
.banner-card {
  position: relative;
  height: 400px;
  padding-left: 20px;
}

.banner-desc {
  text-align: left;
  width: 100%;
  padding-left: 20px;
}

.banner-card img {
  max-width: 100%;
  height: 400px;
}

.banner-text {
  position: absolute;
  top: 0;
}

.underImg {
  position: relative;
}

.overImg {
  position: absolute;
  top: 0px;
  max-width: 100%;
  height: 400px;
  width: 98.5%;
}

.loginErrorModal {
  padding-left: 3px;
}
.loginErrorModal .btn-secondary {
  width: 324px;
}

.modal-header-loginErrorModal {
  padding: 0px !important;
  position: relative;
}

.model-box-loginErrorModal {
  border-radius: 8px;
  animation: animatetop 0.4s;
  background: white;
  margin: 0 auto;
  max-height: 34%;
  max-width: 620px;
  overflow: auto;
  overflow-x: hidden;
  overflow-y: hidden;
  position: relative;
  top: 35%;
  box-shadow: 0 3px 8px 3px rgba(0, 0, 0, 0);
  padding: 10px;
  width: 350px;
}

.modal-cover .model-box-loginErrorModal {
  box-shadow: 0 3px 8px 3px rgba(0, 0, 0, 0);
}

.modal-cover {
  box-shadow: 0 3px 8px 3px rgba(0, 0, 0, 0);
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/home/home.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAjJA;EACI,aAAA;EACA,iBAAA;EACA,iBAAA;AAmJJ;AAjJI;EACI,aAAA;AAmJR;AAjJI;EACI,qBAAA;EAEA,mBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;AAkJR;AA9IQ;EACI,kBAAA;EACA,2BAAA;AAgJZ;AA7IQ;EACI,cAAA;AA+IZ;AA1IQ;EACI,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;AA4IZ;AA3IY;EACI,eAAA;EACA,cAAA;AA6IhB;AA3IY;EACI,YAAA;EACA,eAAA;AA6IhB;AA1IQ;EACI,0BAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,4BAAA;AA4IZ;AA1IQ;EACI,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,4BAAA;AA4IZ;AA1IQ;EACI,aAAA;AA4IZ;;AAvIA;EACI,gCAAA;EACA,qBAAA;EACA,wBAAA;EACA,6BAAA;AA0IJ;;AFlMI;EE4DA;IACI,wBAAA;EA0IN;AACF;AFxMI;EEqEA;IACI,WAAA;IACA,YAAA;IACA,kBAAA;IACA,gBAAA;EAsIN;EAnIE;IACI,WAAA;IACA,YAAA;IACA,kBAAA;IACA,gBAAA;EAqIN;EAlIE;IACI,gBAAA;IACA,gBAAA;EAoIN;EAlIM;IACI,cAAA;EAoIV;EAhIM;IACI,aAAA;IACA,mBAAA;IACA,UAAA;IACA,YAAA;IACA,oBAAA;IACA,mBAAA;IACA,yBAAA;IACA,mBAAA;EAkIV;EAhIU;IACI,aAAA;EAkId;EA/HU;IACI,kBAAA;IACA,gBAAA;IACA,YAAA;IACA,cAAA;IACA,mBAAA;IACA,sBAAA;IACA,kBAAA;IACA,4BAAA;EAiId;EA1HU;IACI,0BAAA;IACA,cAAA;IACA,gBAAA;IACA,iBAAA;IACA,gBAAA;IACA,4BAAA;EA4Hd;EAzHU;IACI,0BAAA;IACA,cAAA;IACA,gBAAA;IACA,iBAAA;IACA,gBAAA;IACA,4BAAA;IACA,aAAA;EA2Hd;EAxHU;IACI,qBAAA;IACA,kBAAA;IACA,mBAAA;IACA,aAAA;IACA,cAAA;EA0Hd;EAzHc;IACI,eAAA;IACA,cAAA;EA2HlB;EAzHc;IACI,YAAA;IACA,eAAA;EA2HlB;EAvHU;IACI,aAAA;EAyHd;AACF;AAlHA;EACI,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;AAoHJ;;AAhHA;EACI,aAAA;EAEA,kBAAA;AAkHJ;;AA/GA;EACI,aAAA;AAkHJ;;AA/GA;EACI,cAAA;AAkHJ;;AA/GA;EACI;IACI,cAAA;IACA,8BAAA;IACA,YAAA;IACA,gBAAA;IACA,kBAAA;EAkHN;EA/GE;IACI,cAAA;EAiHN;EA9GE;IACI,aAAA;EAgHN;EA7GE;IACI,cAAA;EA+GN;AACF;AA5GA;EACI,iBAAA;AA8GJ;;AA5GA;EAEG,qBAAA;EACA,sBAAA;AA8GH;AA7GI;EACI,mBAAA;EACA,0BAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AA+GR;AA7GI;EACI,0BAAA;EACA,iBAAA;EACA,kBAAA;AA+GR;AA7GI;EACI,gBAAA;EACA,WAAA;AA+GR;AA7GI;EACI,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;AA+GR;;AA3GA;EAEI,qBAAA;EAEA,eAAA;AA4GJ;AA3GI;EACI,4BAAA;EACA,iBAAA;EACA,mBAAA;AA6GR;AA5GQ;EACI,iCAAA;EACA,mBAAA;AA8GZ;AA5GQ;EACI,iCAAA;EACA,mBAAA;AA8GZ;AA3GI;EACI,4BAAA;EACA,eAAA;AA6GR;;AAzGA;EACI,mBAAA;EACA,YAAA;EACA,UAAA;AA4GJ;AA3GI;EACI,4BAAA;EACA,iBAAA;EACA,mBAAA;AA6GR;AA5GQ;EACI,iCAAA;EACA,mBAAA;AA8GZ;AA5GQ;EACI,iCAAA;EACA,mBAAA;AA8GZ;AA3GI;EACI,4BAAA;EACA,iBAAA;AA6GR;;AF1YI;EEkSJ;IACI,mBAAA;IACA,8BAAA;IACA,4BAAA;IACA,eAAA;IACA,mBAAA;IACA,YAAA;EA4GF;AACF;AAzGA;EACI,6BAAA;EACA,8BAAA;AA2GJ;;AFzZI;EEkTA;IACI,6BAAA;IACA,8BAAA;EA2GN;AACF;AAxGA;EACI,aAAA;EACA,mBAAA;AA0GJ;;AFpaI;EE8TA;IACI,sBAAA;EA0GN;AACF;AAvGA;EACI,SAAA;AAyGJ;AF7aI;EEmUJ;IAGQ,SAAA;EA2GN;AACF;;AAxGA;EACI,SAAA;AA2GJ;AFtbI;EE0UJ;IAGQ,SAAA;EA6GN;AACF;;AF3bI;EEkVD;IACC,WAAA;EA6GF;AACF;AA1GA;EACI,aAAA;EACA,mBAAA;AA4GJ;;AFrcI;EE6VA;IACI,sBAAA;IACA,mBAAA;IACA,cAAA;EA4GN;AACF;AAzGA;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;AA2GJ;;AAxGA;EACI,cAAA;EACA,8BAAA;AA2GJ;;AAxGE;EACE,aAAA;EACA,kBAAA;AA2GJ;;AAzFE;EAEE;IACE,aAAA;IACA,kBAAA;EA2FJ;EAxFE;IACE,cAAA;IACA,8BAAA;EA0FJ;AACF;AAvFA;EACI;IACI,wBAAA;IACF,gBAAA;EAyFJ;EAvFU;IACI,oBAAA;IACA,qBAAA;EAyFd;AACF;AApFA;EAAQ,aAAA;EAAe,kBAAA;EAAoB,MAAA;EAAQ,iBAAA;AA0FnD;;AAzFA;EACI;IACI,wBAAA;IACF,gBAAA;EA4FJ;AACF;AA1FA;EACI,aAAA;EACA,WAAA;AA4FJ;AA3FI;EACI,wBAAA;EACA,gBAAA;EACA,kBAAA;AA6FR;AA5FQ;EACI,SAAA;EACA,eAAA;EACA,kBAAA;EACA,2BAAA;EACA,WAAA;AA8FZ;AA5FQ;EACI,eAAA;AA8FZ;AA5FQ;EF1aJ,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EE4aQ,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,WAAA;AAkGZ;AAjGY;EACI,6BAAA;EACA,oBAAA;AAmGhB;AAjGY;EAEI,0BAAA;EAEA,2BAAA;EAEA,0BAAA;EACA,sFAAA;EACA,eAAA;EACA,gBAAA;AAmGhB;AAjGY;EACI,0BAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;AAmGhB;AAjGY;EACI,eAAA;AAmGhB;AAjGY;EACI,uBAAA;AAmGhB;AAjGY;EACI,eAAA;AAmGhB;AAjGY;EFhdR,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EEkdY,8BAAA;EACA,uBAAA;EACA,aAAA;AAuGhB;AApGgB;EACI,uBAAA;AAsGpB;AF1kBI;EEsbI;IF1aJ,eAAA;IAAA,eAAA;IAAA,eAAA;IAAA,eAAA;IAAA,eAAA;IE6dY,uBAAA;IACA,YAAA;IACA,YAAA;IACA,QAAA;IACA,UAAA;IACA,UAAA;EA0Gd;EAzGc;IACI,eAAA;IACA,mBAAA;IACA,gBAAA;EA2GlB;EAzGc;IACI,oBAAA;IACA,mBAAA;EA2GlB;EAzGc;IACI,mBAAA;IACA,UAAA;IACA,eAAA;EA2GlB;EAzGc;IACI,gBAAA;IACA,eAAA;EA2GlB;EAzGc;IACI,eAAA;IACA,gBAAA;EA2GlB;EAzGc;IACI,4BAAA;IACA,kBAAA;EA2GlB;AACF;AAzGY;EACE,yBAAA;EACA,0BAAA;AA2Gd;AAzGY;EACE,qBAAA;AA2Gd;AAvGI;EACI,0BAAA;AAyGR;;AApGA;EACI,kBAAA;EACA,MAAA;AAuGJ;AAtGI;EACI,UAAA;AAwGR;AAtGI;EACI,WAAA;AAwGR;;AApGA;EACI,2BAAA;EACA,4BAAA;AAuGJ;;AF7oBI;EE0iBA;IACI,kBAAA;EAuGN;EArGE;IACI,oBAAA;EAuGN;EAtGM;IACI,cAAA;IACA,cAAA;IACA,UAAA;IACA,YAAA;IACA,gBAAA;EAwGV;EAvGU;IACI,gBAAA;EAyGd;EAvGU;IACI,eAAA;EAyGd;EAtGc;IACI,eAAA;EAwGlB;EAtGc;IACI,eAAA;EAwGlB;EApGU;IACI,mBAAA;IACA,gBAAA;IACA,4BAAA;IACA,+BAAA;IACA,kBAAA;IACA,cAAA;IACA,gBAAA;IACA,eAAA;IACA,gBAAA;IACA,cAAA;IACA,4BAAA;EAsGd;EAlGE;IACI,sBAAA;IACA,gBAAA;IACA,eAAA;EAoGN;EAnGM;IACI,0BAAA;IACA,mBAAA;IACA,qBAAA;IACA,gBAAA;EAqGV;EAnGM;IACI,0BAAA;EAqGV;EApGU;IACI,iBAAA;EAsGd;EAnGM;IACI,UAAA;IACA,iBAAA;IACA,kBAAA;IACA,gBAAA;EAqGV;EAnGM;IACI,UAAA;IACA,iBAAA;IACA,kBAAA;IACA,gBAAA;EAqGV;EAlGE;IACI,oBAAA;EAoGN;EAnGM;IACI,eAAA;IACA,mBAAA;EAqGV;EAnGM;IACI,eAAA;IACA,iBAAA;EAqGV;EAlGE;IACI,YAAA;EAoGN;EAnGM;IACI,eAAA;IACA,mBAAA;EAqGV;EAnGM;IACI,eAAA;IACA,iBAAA;EAqGV;EAlGE;IACI,aAAA;IACA,kBAAA;IACA,MAAA;EAoGN;AACF;AAjGA;EACE,yBAAA;EACA,0BAAA;AAmGF;;AAhGA;EACI,8BAAA;EACA,oBAAA;AAmGJ;;AFvvBI;EEwpBJ;IACI,gBAAA;EAmGF;AACF;AF7vBI;EE8pBA;IACI,4BAAA;IACA,kBAAA;EAkGN;AACF;AA/FA;EACI,yBAAA;EACA,qBAAA;EACA,eAAA;AAiGJ;;AA9FC;EACG,0BAAA;AAiGJ;;AA9FA;EACI,cAAA;AAiGJ;;AA9FA;EACI,cAAA;AAiGJ;;AA9FA;EACI,mBAAA;EACA,8BAAA;EACA,4BAAA;EACA,gBAAA;EACA,4BAAA;AAiGJ;;AA9FA;EACI,iBAAA;AAiGJ;;AFhyBI;EEmsBA;IACA,gBAAA;IACA,gBAAA;EAiGF;AACF;AA/FE;EACI,gBAAA;AAiGN;;AA9FE;EACE,8BAAA;AAiGJ;;AF9yBI;EEitBE;IACA,4BAAA;IACA,gBAAA;IACA,mBAAA;EAiGJ;AACF;AA9FE;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,4BAAA;AAgGJ;;AA7FE;EACQ,YAAA;EACA,UAAA;EACA,UAAA;EACA,iBAAA;AAgGV;;AFp0BI;EEyuBA;IACI,0BAAA;EA+FN;EA5FE;IACI,0BAAA;EA8FN;AACF;AA3FA;EACI,kBAAA;EACA,aAAA;EACA,kBAAA;AA6FJ;;AA1FA;EACI,gBAAA;EACA,WAAA;EACA,kBAAA;AA6FJ;;AAzFA;EACI,eAAA;EACA,aAAA;AA4FJ;;AAzFA;EACI,kBAAA;EACA,MAAA;AA4FJ;;AAzFE;EAEE,kBAAA;AA2FJ;;AAzFE;EAEE,kBAAA;EACA,QAAA;EACA,eAAA;EACA,aAAA;EAEA,YAAA;AA0FJ;;AAtFA;EACI,iBAAA;AAyFJ;AAxFE;EACE,YAAA;AA0FJ;;AAtFA;EACE,uBAAA;EACA,kBAAA;AAyFF;;AAtFA;EACI,kBAAA;EACA,0BAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,0CAAA;EACA,aAAA;EACA,YAAA;AAyFJ;;AArFA;EACE,0CAAA;AAwFF;;AArFA;EACE,0CAAA;AAwFF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","// Home page component styling\n@import '../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n.shop-wrapper {\n    padding: 20px;\n    padding-top: 20px;\n    margin-left: 50px;\n\n    .tilesForMobile {\n        display: none;\n    } \n    article {\n        display: inline-block;\n        // max-width: 222px;\n        vertical-align: top;\n        width: 45%;\n        height: 290px;\n        margin-bottom: 25px;\n        margin-right: 12.6px;\n        margin-left: 12.6px;\n        background-color: #ffffff;;\n        border-radius: 30px;\n\n        \n            \n        div {\n            text-align: center;\n            margin: 20px 30px 42px 30px;\n        }\n\n        .tilesForDesktop {\n            display: block;\n        }\n\n        \n\n        a {\n            display: inline-block;\n            text-align: center;\n            margin-bottom: 15px;\n            outline: none;\n            i {\n                font-size: 50px;\n                color: #ffffff;\n            }\n            span {\n                color: black;\n                font-size: 24px;\n            }\n        }\n        p {\n            font-size: 15px !important;\n            color: #000000;\n            text-align: left;\n            line-height: 20px;\n            font-weight: 400;\n            font-family: 'Omnes-ATT-W02';\n        }\n        .heading-4 {\n            margin-bottom: 15px;\n            margin-top: 10px;\n            padding-top: 10px;\n            padding-bottom: 15px;\n            text-align: center;\n            display: block;\n            font-weight: 600; \n            font-size: 23px;\n            text-align: left; \n            color: #363636;\n            font-family: 'Omnes-ATT-W02';\n        }\n        .tilesHeading {\n            display: none;\n        }\n    }\n}\n\n.non5gTiles {\n    display: inline-block !important;\n    width: 30% !important;\n    height: 350px !important;\n    margin-bottom: 0px !important;\n} \n\n@include respond-to(small) {\n    .non5gTiles {\n        display: none !important; \n    }\n}\n\n\n\n@include respond-to(small) {\n\n    .dropdownMenu{\n        width: 30px;\n        float: right; \n        margin-right: 60px;\n        margin-top:-30%;\n    }\n\n    .dropdownMenuUp{\n        width: 30px;\n        float: right; \n        margin-right: 60px;\n        margin-top:-30%;\n    }\n\n    .shop-wrapper {\n        overflow: hidden;\n        font-weight: 500;\n\n        .tilesForMobile {\n            display: block;\n        }\n    \n\n        article {\n            display: none;\n            vertical-align: top;\n            width: 30%;\n            height: 50px;\n            margin-right: 12.6px;\n            margin-left: 12.6px;\n            background-color: #ffffff;;\n            border-radius: 20px;\n\n            .tilesForDesktop {\n                display: none;\n            }\n\n            .heading-4 {\n                position: relative;\n                font-weight: 600;\n                height: auto;\n                display: block;\n                margin-bottom: 10px;\n                padding-bottom: 15px 0;\n                border-radius: 4px;\n                padding-top: 25px !important;\n            }\n\n            // .tilesHeading {\n            //     display: block;\n            // }\n\n            .heading-4:after p {\n                font-size: 15px !important;\n                color: #000000;\n                text-align: left;\n                line-height: 20px;\n                font-weight: 400;\n                font-family: 'Omnes-ATT-W02';\n            }\n\n            .shortDesc {\n                font-size: 15px !important;\n                color: #000000;\n                text-align: left;\n                line-height: 20px;\n                font-weight: 400;\n                font-family: 'Omnes-ATT-W02';\n                display: none;\n            }\n\n            .hideLearnMore {\n                display: inline-block;\n                text-align: center;\n                margin-bottom: 15px;\n                outline: none;\n                color: #FFFFFF;\n                i {\n                    font-size: 50px;\n                    color: #ffffff;\n                }\n                span {\n                    color: black;\n                    font-size: 24px;\n                }\n            }\n\n            a {\n                display: none;\n            }\n    \n        }   \n    }\n}\n\n\n.learn-more-btn {\n    border-radius: 10px;\n    background: #3A6EB2 !important;\n    font-size: 16px;\n    margin-top: inherit;\n    height: 40px;\n    width: 175px;\n    // margin-left: -119px;\n}\n\n.hideArrow {\n    display: none;\n    // visibility: visible !important;\n    visibility: hidden;\n}\n\n.benefit-header {\n    display: none;\n}\n\n.hide-benefit {\n    display: block;\n}\n\n@media (max-width: 1024px) {\n    .hideArrow {\n        display: block;\n        visibility: visible !important;\n        float: right; \n        margin-top: 40px; \n        margin-right: -12%;\n    }\n\n    .benefit-header {\n        display: block;\n    }\n\n    .hide-benefit {\n        display: none;\n    }\n\n    a {\n        color: #191919;\n    }\n}\n\n.firstNetTC{\n    padding-top: 26px;\n}\n.marketplace-benefit {\n   // background: #ffffff;\n   background: aliceblue;\n   padding: 20px 0 40px 0;\n    h2 {\n        margin-bottom: 20px;\n        font: 18px 'Omnes-ATT-W02';\n        text-align: center;\n        font-size: 34px;\n        font-weight: 900;\n    }\n    .subtitle {\n        font: 16px 'Omnes-ATT-W02';\n        line-height: 22px;\n        margin: 0 0 0 20px;\n    }\n    img {\n        max-width: 240px;\n        width: 100%;\n    }\n    .small-container-flex {\n        max-width: 240px;\n        width: 100%;\n        margin-left: 10%;\n        margin-right: 10%;\n    }\n}\n\n.signup-section {\n    //background: #f2f2f2;\n    background: aliceblue;\n   // color: color(default, light);\n    padding: 10px 0;\n    h3 {\n        font-family: 'Omnes-ATT-W02';\n        font-size: 1.8rem;\n        margin-bottom: 26px;\n        &.contact-number {\n            font: 2rem 'Omnes-ATT-W02-Medium';\n            margin-bottom: 12px;\n        }\n        &.contact-number-last {\n            font: 2rem 'Omnes-ATT-W02-Medium';\n            margin-bottom: 20px;\n        }\n    }\n    p {\n        font-family: 'Omnes-ATT-W02';\n        font-size: 15px;\n    }\n}\n\n.signup-section-fn {\n    background: color(inverse, dark);\n    color: color(default, light);\n    padding: 0;\n    h3 {\n        font-family: 'Omnes-ATT-W02';\n        font-size: 1.8rem;\n        margin-bottom: 26px;\n        &.contact-number {\n            font: 2rem 'Omnes-ATT-W02-Medium';\n            margin-bottom: 12px;\n        }\n        &.contact-number-last {\n            font: 2rem 'Omnes-ATT-W02-Medium';\n            margin-bottom: 20px;\n        }\n    }\n    p {\n        font-family: 'Omnes-ATT-W02';\n        font-size: 1.8rem;\n    }\n}\n\n@include respond-to('small') {\n.learn-more-btn {\n    border-radius: 10px;\n    background: #3A6EB2 !important;\n    font-family: 'Omnes-ATT-W02';\n    font-size: 16px;\n    margin-top: inherit;\n    height: 40px;\n    // margin-left: -65px;\n}}\n\n.inner-container-box {\n    padding-left: 60px !important;\n    padding-right: 60px !important;\n}\n\n@include respond-to('small') {\n    .inner-container-box {\n        padding-left: 10px !important;\n        padding-right: 10px !important;\n    }  \n}\n\n.terms {\n    display: flex;\n    flex-direction: row;\n}\n\n@include respond-to (small) {\n    .terms {\n        flex-direction: column;\n    }\n}\n\n.termscolumns1 {\n    flex: 55%;\n    @include respond-to('small') {\n        flex: 50%;\n    }\n}\n\n.termscolumns2 {\n    flex: 45%;\n    @include respond-to('small') {\n        flex: 50%;\n    }\n}\n\n@include respond-to (small) {\n   .termscols {\n    float: left;\n} \n}\n\n.container-flex {\n    display: flex;\n    flex-direction: row;\n}\n\n@include respond-to('small') {\n    .container-flex {\n        flex-direction: column;\n        align-items: center;\n        display: block;\n    }\n}\n\n.footer-description {\n    font-size: 15px;\n    color: #000000;\n    opacity: 1;\n    margin-bottom: 0px;\n}\n\n.hide-small {\n    display: block;\n    visibility: visible !important;\n  }\n  \n  .show-small {\n    display: none;\n    visibility: hidden;\n  }\n\n  \n//   @media (max-widt: 767px) {\n    // .article-info {\n\n    // }\n\n//     .shop-wrapper:after {\n//         content: \"\";\n//         position: absolute;\n//         right: 15px;\n//         top: 20px;\n//         width: 18px;\n//         height: 18px;\n//     }\n//   }\n  @media (max-width: 1024px) {\n  \n    .hide-small {\n      display: none;\n      visibility: hidden;\n    }\n  \n    .show-small {\n      display: block;\n      visibility: visible !important;\n    }\n  }\n// styles for slider section\n@media (min-width: 501px) and (max-width: 1024px) {\n    app-page-slider {\n        height: 266px !important;\n      margin-top: 50px;\n        .page {\n            .caption-text {\n                left: 10% !important;\n                width: 60% !important;\n            }\n        }\n    }\n} \n\n.inner{ height: 500px; position: absolute; top: 0; will-change: left; }\n@media(max-width: 500px) {\n    app-page-slider {\n        height: 266px !important;\n      margin-top: 50px;\n    }\n}\napp-page-slider {\n    height: 436px;\n    width: 100%;\n    .page {\n        height: 436px !important;\n        overflow: hidden;\n        text-align: center;\n        img {\n            left: 50%;\n            max-width: none;\n            position: absolute;\n            transform: translateX(-50%);\n            width: auto;\n        }\n        small {\n            font-size: 11px;\n        }\n        .caption-text {\n            @include vendor-prefix('transform', translateY(-50%));\n            font-size: 1.4rem;\n            position: absolute;\n            text-align: left;\n            top: 152px;\n            width: 100%;\n            .container-inner {\n                padding-left: 80px !important;\n                padding-right: 120px;\n            }\n            .btn-primary {\n                background: -webkit-linear-gradient(to bottom, color(primary, base) 100%, color(primary, base) 50%, color(primary, base) 0%, #d16500);\n                /* For Safari 5.1 to 6.0 */\n                background: -o-linear-gradient(to bottom, color(primary, base) 100%, color(primary, base) 50%, color(primary, base) 0%, #d16500);\n                /* For Opera 11.1 to 12.0 */\n                background: -moz-linear-gradient(to bottom, color(primary, base) 100%, color(primary, base) 50%, color(primary, base) 0%, #d16500);\n                /* For Firefox 3.6 to 15 */\n                background: linear-gradient(to bottom, color(primary, base) 100%, color(primary, base) 50%, color(primary, base) 0%, #d16500);\n                font-size: 20px;\n                padding-top: 7px;\n            }\n            h1 {\n                font: 38px 'Omnes-ATT-W02';\n                line-height: normal;\n                font-weight: 430;\n                margin-bottom: 15px;\n                margin-top: 0;\n            }\n            .eyebrow-text {\n                font-size: 18px;\n            }\n            .caption-white {\n                color: color(default, light) !important;\n            }\n            p {\n                font-size: 16px;\n            }\n            .caption-background {\n                @include vendor-prefix('border-radius', 8px);\n                background: rgba(0, 0, 0, .8);\n                color: color(default, light) !important;\n                padding: 30px;\n            }\n            .carouselDiv0 .carouselDiv2 {\n                h1 {\n                    color: color(default, light) !important;\n                }\n            }\n            @include respond-to (small) {\n                @include vendor-prefix('transform', none);\n                background: transparent;\n                bottom: 90px;\n                color: color(default, light);\n                top: 0px;\n                left: 20px;\n                width: 70%;\n                h1 {\n                    font-size: 2rem;\n                    margin-bottom: 10px;\n                    margin-top: 14px;\n                }\n                p {\n                    line-height: initial;\n                    margin-bottom: 14px;\n                }\n                .btn {\n                    margin-bottom: 20px;\n                    width: 50%;\n                    font-size: 12px;\n                }\n                .caption-background {\n                    background: none;\n                    padding: 0 15px;\n                }\n                .eyebrow-text {\n                    font-size: 14px;\n                    margin-top: 20px;\n                }\n                .container-inner {\n                    padding-left: 0px !important;\n                    padding-right: 0px;\n                }\n            }\n            a {\n              color: rgb(255, 255, 255);\n              text-decoration: underline;\n            }\n            a.btn-secondary {\n              text-decoration: none;\n            }\n        }\n    }\n    .right-nav {\n        font-size: 50px !important;\n    }\n}\n\n\napp-nav-button {\n    position: absolute;\n    top: 0;\n    &[backward] {\n        left: 15px;\n    }\n    &[forward] {\n        right: 15px;\n    }\n}\n\n.row {\n    margin-left: 0px !important;\n    margin-right: 0px !important;\n}\n\n@include respond-to (small) {\n    .btn {\n        text-align: center;\n    }\n    .shop-wrapper {\n        padding: 40px 0 10px;\n        article {\n            display: block;\n            margin: 0 auto;\n            width: 90%;\n            height: 100%;\n            margin-left: 0px;\n            .align {\n                padding-top: 0px;\n            }\n            p {\n                font-size: 14px;\n            }\n            a {\n                span {\n                    font-size: 18px;\n                }\n                i {\n                    font-size: 36px;\n                }\n            }\n\n            .heading-4 {\n                margin-bottom: 15px;\n                margin-top: 10px;\n                padding-top: 20px !important;\n                padding-bottom: 20px !important;\n                text-align: center;\n                display: block;\n                font-weight: 600; \n                font-size: 23px;\n                text-align: left; \n                color: #363636;\n                font-family: 'Omnes-ATT-W02'; \n            }\n        }\n    }\n    .marketplace-benefit {\n        padding: 30px 0 20px 0;\n        margin-right: 2%;\n        margin-left: 2%;\n        h2 {\n            font: 26px 'Omnes-ATT-W02';\n            margin-bottom: 30px;\n            margin: 55px 0 10px 0;\n            font-weight: 900;\n        }\n        .subtitle {\n            font: 14px 'Omnes-ATT-W02';\n            li {\n                line-height: 10px;\n            }\n        }\n        img {\n            padding: 0;\n            margin-left: auto;\n            margin-right: auto;\n            max-width: 300px;\n        }\n        .small-container-flex {\n            padding: 0;\n            margin-left: auto;\n            margin-right: auto;\n            max-width: 300px;\n        }\n    }\n    .signup-section {\n        padding: 10px 0 10px;\n        h3 {\n            font-size: 14px;\n            margin-bottom: 20px;\n        }\n        p {\n            font-size: 15px;\n            line-height: 18px\n        }\n    }\n    .signup-section-fn {\n        padding: 0px;\n        h3 {\n            font-size: 14px;\n            margin-bottom: 20px;\n        }\n        p {\n            font-size: 14px;\n            line-height: 18px\n        }\n    }\n    app-nav-button {\n        display: none;\n        position: absolute;\n        top: 0;\n    }\n}\n\n.link-white {\n  color: rgb(255, 255, 255);\n  text-decoration: underline;\n}\n\n:host ::ng-deep .container-box.inner-wrap {\n    padding-left: 200px !important;\n    padding-right: 200px;\n}\n\n@include respond-to('small') {\n.second-row {\n    max-width: 360px;\n}\n}\n\n@include respond-to('small') {\n    :host ::ng-deep .container-box.inner-wrap {\n        padding-left: 0px !important;\n        padding-right: 0px;\n    }\n}\n\n:host ::ng-deep .link-text {\n    color: #1483d9 !important;\n    text-decoration: none;\n    font-size: 15px;\n  }\n\n :host ::ng-deep .link-text:hover {\n    text-decoration: underline;\n  } \n\n:host ::ng-deep i.nav-right-icon {\n    color: #f2f2f2;\n}\n\n:host ::ng-deep i.nav-left-icon {\n    color: #f2f2f2;\n}\n\n.learn-more-button {\n    border-radius: 10px;\n    background: #f2f2f2 !important;\n    padding: 10px 18px 10px 18px;\n    font-weight: 500;\n    font-family: 'Omnes-ATT-W02';\n}\n\n.left-align {\n    text-align: right;\n}\n\n@include respond-to('small') {\n    .left-align {\n    margin-top: 10px;\n    text-align: left;\n}\n}\n  .small-container-flex {\n      display: flexbox;\n  }\n\n  .article-list {\n    transform: translate(0%, -25%);\n  }\n\n  @include respond-to('small') {\n      .article-list {\n      transform: translate(0%, 0%);\n      padding-top: 0px;\n      padding-bottom: 0px;\n      }\n  }\n\n  .slider-heading {\n    color: #FFFFFF;\n    font-weight: 400;\n    font-size: 35px;\n    line-height: 21px;\n    font-family: 'Omnes-ATT-W02';\n}\n\n  :host ::ng-deep app-page-slider[_ngcontent-yqi-c10] .page[_ngcontent-yqi-c10] .caption-text[_ngcontent-yqi-c10] {\n          bottom: 90px;\n          left: 46px;\n          width: 65%;\n          margin-top: -20px;\n\n      } \n\n@include respond-to('small') {\n    .slider-title {\n        font-size: 26px !important;\n      //  font-size: 17px !important;\n    }\n    .slider-short-description {\n        font-size: 12px !important;\n    }\n}\n\n.banner-card {\n    position: relative;\n    height:400px; \n    padding-left: 20px;\n}\n\n.banner-desc {\n    text-align: left; \n    width: 100%; \n    padding-left: 20px; \n   // padding-top: 7%;\n}\n\n.banner-card img{\n    max-width: 100%;\n    height: 400px;\n}\n\n.banner-text {\n    position: absolute;\n    top: 0;\n}\n\n  .underImg\n  {\n    position: relative;\n  }\n  .overImg\n  {\n    position: absolute;\n    top: 0px;\n    max-width: 100%;\n    height: 400px;\n    // padding-left: 20px;\n    width: 98.5%;\n  }\n\n//profile error modal css\n.loginErrorModal{\n    padding-left: 3px;\n  .btn-secondary{\n    width: 324px;\n  }\n}\n\n.modal-header-loginErrorModal{\n  padding: 0px !important;\n  position: relative;\n}\n\n.model-box-loginErrorModal{\n    border-radius: 8px;\n    animation: animatetop 0.4s;\n    background: white;\n    margin: 0 auto;\n    max-height: 34%;\n    max-width: 620px;\n    overflow: auto;\n    overflow-x: hidden;\n    overflow-y: hidden;\n    position: relative;\n    top: 35%;\n    box-shadow: 0 3px 8px 3px rgba(0, 0, 0, 0);\n    padding: 10px;//20px 0 0px 9px;\n    width: 350px;\n    // height: 182px;\n}\n\n.modal-cover .model-box-loginErrorModal{\n  box-shadow: 0 3px 8px 3px rgba(0, 0, 0, 0);;\n}\n\n.modal-cover{\n  box-shadow: 0 3px 8px 3px rgba(0, 0, 0, 0);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
